import { SendOtpReq, SendOtpRes, UpdatePasswordReq } from './types/index'
import QueryTags from '../../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'
import { NotificationSettingReq, NotificationSettingRes } from './types'

const notificationPath = '/notification/v1'
const adminPath = '/administration/api'

const notificationEndPoint = (
  builder: EndpointBuilder<
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
    QueryTags,
    'data'
  >
) => ({
  getNotificationSetting: builder.query<NotificationSettingRes, string>({
    query: (customerId) => {
      return {
        url: `${notificationPath}/settings/${customerId}/otp-preferences`,
        method: 'GET',
      }
    },
  }),

  updateNotificationSetting: builder.mutation<
    NotificationSettingReq,
    NotificationSettingReq
  >({
    query: (body) => {
      const { userId } = body
      delete body.userId
      return {
        url: `${notificationPath}/settings/${userId}/otp-preferences`,
        method: 'PATCH',
        body,
      }
    },
  }),

  sendOtp: builder.mutation<SendOtpRes, SendOtpReq>({
    query: (body) => {
      return {
        url: `${adminPath}/customers/${body.userId}/send-otp?otpType=${body.otpType}`,
        method: 'POST',
        body,
      }
    },
  }),

  updatePassword: builder.mutation<UpdatePasswordReq, UpdatePasswordReq>({
    query: (body) => {
      const { customerId } = body
      delete body.customerId
      return {
        url: `${adminPath}/customers/${customerId}/change-password`,
        method: 'PATCH',
        body,
      }
    }
  }),

  generateTOTP: builder.mutation<{totpSecret: string, totpUri: string,}, {profileId: string,}>({
    query: ({profileId}) => {
      return {
        url: `${adminPath}/customers/${profileId}/totp-secret`,
        method: 'POST',
      }
    },
  }),

  enableTOTP: builder.mutation<string, {profileId: string, otpCode: string,}>({
    query: ({profileId, otpCode}) => {
      return {
        url: `${adminPath}/customers/${profileId}/enable-totp-secret`,
        method: 'POST',
        body: { otpCode }
      }
    },
  }),
})

export default notificationEndPoint
